import { render, staticRenderFns } from "./globalUploader.vue?vue&type=template&id=40d03232&scoped=true"
import script from "./globalUploader.vue?vue&type=script&lang=js"
export * from "./globalUploader.vue?vue&type=script&lang=js"
import style0 from "./globalUploader.vue?vue&type=style&index=0&id=40d03232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d03232",
  null
  
)

export default component.exports